import Styles from "./study.module.css";
import { SubHeader } from "../../components/shared/subHeader";
import { Link, Outlet, Route, useResolvedPath } from "react-router";

import { Main } from "./Main";
import { usePortal } from "../../hooks/store";
import { useEffect, useRef } from "react";
import { CustomNavLink } from "../../components/shared/customNavLink/CustomNavLink";
export default function Study() {
  const path = useResolvedPath();

  // console.log(path);
  return (
    <main className={`content ${Styles.study_content}`} id="study">
      <SubHeader>
        <CustomNavLink is_active={path.pathname === "/"} path={""}>
          <p>Билеты ПДД ПМР</p>
        </CustomNavLink>
        <CustomNavLink
          is_active={path.pathname.includes("theme")}
          path={"theme"}>
          <p>Вопросы по темам</p>
        </CustomNavLink>
        <CustomNavLink is_active={path.pathname.includes("exam")} path={"exam"}>
          <p>Экзамен ПДД ПМР</p>
        </CustomNavLink>
        <CustomNavLink
          is_active={path.pathname.includes("marathon")}
          path={"marathon"}>
          <p>Марафон ПДД ПМР</p>
        </CustomNavLink>
        <CustomNavLink
          is_active={path.pathname.includes("video")}
          path={"video"}>
          <p>Видеоуроки</p>
        </CustomNavLink>
        <CustomNavLink is_active={path.pathname.includes("pdd")} path={"pdd"}>
          <p>ПДД</p>
        </CustomNavLink>
      </SubHeader>
      <Outlet />
    </main>
  );
}
